const easing = [0.6, -0.05, 0.01, 0.99];

export default {
  faderight: {
    x: -60,
    opacity: 0,
  },
  normal: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
  exit: {
    x: -60,
    opacity: 0,
  },
};
